module.exports = __webpack_public_path__ + "static/media/spinner.da6b116a.svg";